// RateTypeList.jsx
import React, { useEffect, useState } from "react";

import AddRateType from "./Components/AddRateType";
import EditRateType from "./Components/EditRateType";
import RateTypeTable from "./Components/RateTypeTable";
import Swal from "sweetalert2";
import api from "../../../../../api/axios";
import BackButton from "../BackButton";

const RateTypeList = () => {
  const [rateTypes, setRateTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [roomTypes, setRoomTypes] = useState([]);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedRateType, setSelectedRateType] = useState(null);

  const fetchRateTypes = async () => {
    setLoading(true);
    try {
      const res = await api.get("/pms/rate-types");
      setRateTypes(res.data.data || res.data || []);
    } catch (err) {
      console.error("Failed to fetch rate types:", err);
      setRateTypes([]);
    } finally {
      setLoading(false);
    }
  };

  const loadRoomTypes = async () => {
    try {
      const res = await api.get("/pms/room-types");
      setRoomTypes(res.data || []);
    } catch (err) {
      console.error("Failed to load room types:", err);
    }
  };

  useEffect(() => {
    fetchRateTypes();
    loadRoomTypes();
  }, []);

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the rate type.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Delete",
    });

    if (confirm.isConfirmed) {
      try {
        await api.delete(`/pms/rate-types/${id}`);

        Swal.fire({
          icon: "success",
          title: "Deleted",
          timer: 1200,
          showConfirmButton: false,
        });

        fetchRateTypes();
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Delete Failed",
          text: err.response?.data?.message || "Something went wrong.",
        });
      }
    }
  };

  const openEdit = (rt) => {
    setSelectedRateType(rt);
    setIsEditOpen(true);
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <BackButton />

          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Rate Type List</h3>

            <button className="btn btn-dark" onClick={() => setIsAddOpen(true)}>
              Add Rate Type
            </button>
          </div>
        </div>

        <div className="card mt-3">
          <div className="card-body">
            <RateTypeTable
              data={rateTypes}
              loading={loading}
              onEdit={openEdit}
              onDelete={handleDelete}
            />
          </div>
        </div>

        <AddRateType
          open={isAddOpen}
          onClose={() => setIsAddOpen(false)}
          onAdded={fetchRateTypes}
          roomTypes={roomTypes}
        />

        <EditRateType
          open={isEditOpen}
          onClose={() => setIsEditOpen(false)}
          rateType={selectedRateType}
          onUpdated={fetchRateTypes}
          roomTypes={roomTypes}
        />
      </div>
    </div>
  );
};

export default RateTypeList;
